<template>
  <el-dropdown trigger="click">
    <el-badge :value="totalNum" class="notice" :hidden="totalNum === 0" :max="99">
      <svg-icon icon-class="notice" />
    </el-badge>
    <el-dropdown-menu slot="dropdown">
      <div class="notify-container">
        <div class="notify-nav">
          <p :class="{ active: active === 1 }" @click="changeType(1)">待办({{ todoNum }})</p>
          <p :class="{ active: active === 2 }" @click="changeType(2)">抄送({{ copyNum }})</p>
          <p :class="{ active: active === 3 }" @click="changeType(3)">通知({{ noticeNum }})</p>
        </div>
        <div v-show="active === 1" ref="waiting" class="notify-content">
          <div v-for="item in todoList.slice(0, todoPage * 5)" :key="item.messageId" class="notify-item" @click="showNotify(item)">
            <p class="title">{{ item.content }}</p>
            <p class="time">{{ item.receiveTime || '-' }}</p>
          </div>
          <span v-if="todoList.length === 0" class="no-notify">
            <svg-icon icon-class="nodata" />
          </span>
        </div>
        <div v-show="active === 2" ref="copy" class="notify-content">
          <div v-for="item in copyList.slice(0, copyPage * 5)" :key="item.messageId" class="notify-item" @click="showNotify(item)">
            <p class="title">{{ item.content }}</p>
            <p class="time">{{ item.receiveTime || '-' }}</p>
          </div>
          <span v-if="copyList.length === 0" class="no-notify">
            <svg-icon icon-class="nodata" />
          </span>
        </div>
        <div v-show="active === 3" ref="notify" class="notify-content">
          <div v-for="item in noticeList.slice(0, noticePage * 5)" :key="item.messageId" class="notify-item" @click="showNotify(item)">
            <p class="title message-title" v-html="item.contentTitle" />
            <p class="time">{{ item.receiveTime || '-' }}</p>
          </div>
          <span v-if="noticeList.length === 0" class="no-notify">
            <svg-icon icon-class="nodata" />
          </span>
        </div>
        <div class="notify-divider" />
        <div class="more">
          <p class="clear" @click="clearAll">{{ clearName }}</p>
          <p @click="addMore">加载更多</p>
        </div>
      </div>
    </el-dropdown-menu>
    <el-dialog
      :close-on-click-modal="false"
      :title="noticeTitle"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <div class="notify-dialog">
        <p class="notify-dialog-title" v-html="noticeData.content" />
        <div class="notify-dialog-content">
          <div>
            <p class="label">发起人</p>
            <p class="itme">{{ noticeData.startUser || '-' }}</p>
          </div>
          <div>
            <p class="label">发起时间</p>
            <p class="item">{{ noticeData.startTime || '-' }}</p>
          </div>
        </div>
        <div class="noify-btn">
          <el-button type="primary" size="small" @click="sureNotify">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <apply-drawer ref="applyDrawer" @refresh="refresh" />
  </el-dropdown>
</template>

<script>
import BpmSocket from '@/utils/webSocket'
import { mapState } from 'vuex'
import { getToken } from '@/utils/auth'
import { getMessageNotice, getMessageRead, clearMessageNotice, judgeShowNotice } from '@/views/approvalCenter/api'
import NotifyItem from '@/views/notification/components/item'
export default {
  name: 'DropdownNotify',
  components: {
    applyDrawer: () => import('@/views/taskManage/components/taskDrawer.vue')
  },
  props: {},
  data() {
    return {
      todoLoading: false,
      copyLoading: false,
      noticeLoading: false,
      todoPage: 1,
      copyPage: 1,
      noticePage: 1,
      totalNum: 0,
      active: 1,
      dialogVisible: false, // 显示通知具体内容
      copyList: [],
      copyNum: 0,
      noticeList: [],
      noticeNum: 0,
      todoList: [],
      todoNum: 0,
      noticeData: {} // 点击查看详情
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    noticeTitle() {
      let name = ''
      switch (this.active) {
        case 1:
          name = '待办详情'
          break
        case 2:
          name = '抄送详情'
          break
        case 3:
          name = '通知详情'
          break
        default:
          name = '待办详情'
      }
      return name
    },
    clearName() {
      let name = ''
      switch (this.active) {
        case 1:
          name = '清除待办'
          break
        case 2:
          name = '清除抄送'
          break
        case 3:
          name = '清除通知'
          break
        default:
          name = '清除所有'
      }
      return name
    }
  },
  created() {
    this.getNoticeList()
    // 定时轮循获取小铃铛数据
    // this.timer = setInterval(() => {
    //   this.getNoticeList()
    // }, 8000)
  },
  mounted() {
    if (getToken()) {
      this.initSocket()
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.socket && this.socket.close()
    this.socket = null
  },
  methods: {
    // 初始化socket
    initSocket() {
      const sessionAppId = sessionStorage.getItem('appId')
      const appId = this.$store.state.user.userInfo.appId
      this.socket = new BpmSocket(process.env.VUE_APP_NOTICE_SOCKET + this.userInfo.userId + `-${sessionAppId || appId}`, this.handleMessage.bind(this))
      this.socket.connect()
    },
    async handleMessage(message) {
      // debugger
      console.log(message, 'handleMessage')
      const { code } = await judgeShowNotice()
      if (code === 200) {
        if (message.msgType) {
          this.notify(message)
          // 刷新小铃铛
          this.getNoticeList()
        }
      }
    },
    notify(data) {
      // debugger
      // data = { icon: 4, 'content': '部门负责人审批3关洪颜调休-多级level', 'msgType': 1, 'msgTypeName': '通知', 'operationType': 3, 'operationTypeName': '发起', 'procInstId': 'db3ff14f-34bc-11ed-b922-5811220912e4', 'title': '消息', 'wsContent': '【调休-多级level】 您有一条待审批' }
      this.$notify({
        title: '',
        duration: 20000,
        position: 'top-right',
        customClass: 'bpm-notify',
        message: this.$createElement(NotifyItem, { props: { detail: data }, on: { dealMessage: this.dealMessage }})
      })
    },
    // 刷新数据
    refresh() {
      this.$store.dispatch('home/relaod_view')
    },
    dealMessage(detail, msgType, operationType) {
      // 处理消息
      if (detail.msgType === 3 && operationType === 0) {
        this.$router.push('/taskManage/pending')
      } else {
        const applyDrawer = this.$refs.applyDrawer
        if (detail && detail.businessDataKey && detail.businessDataKey.indexOf('YD') > -1) {
          // 因为业财的要做iframe跨域通信，所以不能同时打开两个窗口，这两绑定的message会有两个，数据会乱，所以这里当关闭当前的
          const btn = document.querySelector('.myTaskDrawer .close-drawer-icon')
          if (btn) {
            btn.click()
          }
          this.$nextTick(() => {
            applyDrawer.viewType = 'yc'
            applyDrawer.openDrawer(detail, msgType)
          })
        } else {
          applyDrawer.viewType = ''
          applyDrawer.openDrawer(detail, msgType)
        }
      }
    },
    // 获取小铃铛数据
    async getNoticeList() {
      try {
        const res = await getMessageNotice()
        if (res.code === 200 && res.data) {
          const { copyList, copyNum, noticeList, noticeNum, todoList, todoNum, totalNum } = res.data
          this.copyList = copyList
          this.copyNum = copyNum
          this.noticeList = noticeList
          this.noticeNum = noticeNum
          this.todoList = todoList
          this.todoNum = todoNum
          this.totalNum = totalNum
        }
      } catch (err) {
        console.log('err', err)
      }
    },
    goPage(name) {
      this.$router.push({ name })
    },
    changeType(active) {
      this.active = active
    },
    // 全部清除
    async clearAll() {
      const page = this.active
      const typeMap = {
        1: 3,
        2: 2,
        3: 1
      }
      const pageMap = {
        1: 'todoPage',
        2: 'copyPage',
        3: 'noticePage'
      }
      const loadingMap = {
        1: 'todoLoading',
        2: 'copyLoading',
        3: 'noticeLoading'
      }
      if (this[loadingMap[page]]) return
      this[loadingMap[page]] = true
      const type = typeMap[page]
      try {
        const res = await clearMessageNotice({ type })
        if (res.code === 200) {
          this.getNoticeList()
          // 重置page
          this[pageMap[page]] = 1
        }
      } finally {
        this[loadingMap[page]] = false
      }
    },
    // 加载更多消息
    addMore() {
      if (this.active === 1 && this.todoNum <= this.todoPage * 5) {
        return this.$message.error('暂无更多待办消息')
      } else if (this.active === 2 && this.copyNum <= this.copyPage * 5) {
        return this.$message.error('暂无更多抄送消息')
      } else if (this.active === 3 && this.noticeNum <= this.noticePage * 5) {
        return this.$message.error('暂无更多通知消息')
      }
      // 后面根据接口调整
      const refMaps = {
        1: 'waiting',
        2: 'copy',
        3: 'notify'
      }
      const ref = refMaps[this.active]
      if (this.active === 1) {
        this.todoPage = this.todoPage + 1
      } else if (this.active === 2) {
        this.copyPage = this.copyPage + 1
      } else if (this.active === 3) {
        this.noticePage = this.noticePage + 1
      }
      this.$nextTick(() => {
        this.$refs[ref].scrollTo({
          top: this.$refs[ref].scrollHeight,
          behavior: 'smooth'
        })
      })
    },
    // 显示通知
    showNotify(item) {
      this.noticeData = item
      this.dialogVisible = true
    },
    // 确认查看消息
    async sureNotify() {
      if (this.noticeData && this.noticeData.messageId) {
        try {
          const res = await getMessageRead(this.noticeData.messageId)
          if (res.code === 200) {
            this.getNoticeList()
            this.dialogVisible = false
          }
        } finally {
          this.dialogVisible = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/.el-dialog {
    .el-dialog__header {
      padding: 16px 24px;
      border-bottom: 1px solid #ebebeb;
    }
    .el-dialog__headerbtn {
      top: 16px;
      display: none;
    }
  }
  .notify-container {
      width: 360px;
      padding: 6px 16px 0px 16px;
      .notify-nav {
        width: 100%;
        padding: 4px;
        background: #F2F3F5;
        border-radius: 4px;
        display: flex;
        p {
          flex: 1;
          height: 32px;
          font-size: 14px;
          font-weight: 500;
          color: #4E5969;
          line-height: 32px;
          text-align: center;
          cursor: pointer;
          &.active {
            background: #FFFFFF;
            border-radius: 4px;
            color: #165DFF;
          }
        }
      }
      .notify-content  {
        height: 346px;
        overflow-y: auto;
        position: relative;
        .no-notify {
          position: absolute;
          top: 120px;
          left: 50%;
          transform: translateX(-50%);
          svg {
            font-size: 100px;
          }
        }
        >div:nth-last-of-type(1) {
          border-bottom: none;
        }
        .notify-item {
          position: relative;
          padding: 12px 4px;
          border-bottom: 1px solid #EBEBEB;
          &:hover {
            .title {
              color: #165DFF;
            }
            span {
            color: #165DFF !important;
          }
          }
          span {
            color: #4E5969 !important;
          }
          .title {
            font-size: 14px;
            font-weight: 500;
            color: #4E5969;
            line-height: 20px;
            padding-bottom: 4px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          .message-title {
            /deep/span {
              color: #333333 !important;
            }
            &:hover {
              /deep/span {
              color: #165DFF !important;
            }
            }
          }
          .time {
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
          }
        }
      }
      .notify-divider {
        width: calc(100% + 32px);
        border-bottom: 1px solid #EBEBEB;
        margin-left: -16px;
      }
      .more {
        padding-top: 13px;
        padding-bottom: 13px;
        width: 100%;
        color: #666666;
        font-size: 14px;
        text-align: center;
        transition: color 0.3s;
        cursor: pointer;
        display: flex;
        align-items: center;
        p {
          flex: 1;
          text-align: center;
          &:hover {
            color: #2C51EF;
          }
          &.clear {
            position: relative;
            &::after {
              content: '';
              position: absolute;
              right: 0px;
              width: 1px;
              height: 32px;
              background: #EBEBEB;
              top: -6px;
            }
          }
        }
      }
    }
  /deep/.el-dialog__body {
    padding: 24px;
    .notify-dialog-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #333333;
      padding-bottom: 16px;
      span {
        color: #333333 !important;
      }
    }
    .notify-dialog-content {
      display: flex;
      >div {
        flex: 1;
        .label {
          font-size: 12px;
          color: #999999;
          line-height: 20px;
        }
        .item {
          padding-top: 2px;
          line-height: 20px;
          font-size: 12px;
          color: #333333;
        }
      }
    }
    .noify-btn {
      width: 100;
      display: flex;
      justify-content: flex-end;
      padding-top: 16px;
    }
  }
</style>
